export * from './drag-and-drop.module';
export * from './draggable-helper.provider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-draggable-droppable/dist/esm/src/index.js
// module id = ./node_modules/angular-draggable-droppable/dist/esm/src/index.js
// module chunks = 3